var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group btn-group-sm"},[_c('button',{staticClass:"btn btn-info",class:{ '-nested-comp-open-btn': _vm.isDisplayRowVisible },attrs:{"title":"Reports View"},on:{"click":function($event){return _vm.toggleNestedComp('Reports')}}},[_c('i',{staticClass:"fa fa-list-ul"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }